// Generated by scripts/import_piano.ts. Do not edit by hand.
import type { SonataFile } from '../sonatas/types';
import p0 from './json/op76-2.json';

/** Piano pieces imported from MIDI, read by rule (compact; decode with ../chorales/codec.ts). */
export const PIANO_FILES: SonataFile[] = [p0 as unknown as SonataFile];
